// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".frame {\n  height: 100%;\n  width: 100%;\n  border-width: 0px;\n}\n\n.main {\n  height: 100%;\n  width: 100%;\n}\n\n.list-wrapper {\n  z-index: 100;\n  position: fixed;\n  right: 10px;\n  top: 10px;\n  float: right;\n  width: 120px;\n  background-color: whitesmoke;\n}", ""]);
// Exports
module.exports = exports;
